/** How many images may download at once; avatars are 1-3 MB originals, so a long list must not start them all together. */
export const MAX_CONCURRENT_IMAGES = 4;

export interface ImageSlotRequest {
  /** Gives the slot back (the image finished or failed); also drops a request that was never granted. */
  release: () => void;
}

let active = 0;
const waiting: Array<{ granted: boolean; grant: () => void }> = [];

function pump(): void {
  while (active < MAX_CONCURRENT_IMAGES && waiting.length > 0) {
    const next = waiting.shift()!;
    next.granted = true;
    active += 1;
    next.grant();
  }
}

/** Asks for a download slot; `onGranted` runs once one is free (immediately when there is one). */
export function requestImageSlot(onGranted: () => void): ImageSlotRequest {
  const entry = { granted: false, grant: onGranted };
  let released = false;
  waiting.push(entry);
  pump();

  return {
    release: () => {
      if (released) return;
      released = true;
      if (entry.granted) {
        active -= 1;
      } else {
        waiting.splice(waiting.indexOf(entry), 1);
      }
      pump();
    },
  };
}
